import { HttpContextToken } from '@angular/common/http';

/** Opt a request out of HttpTimeoutInterceptor's connectivity/error toasts — for background,
 *  fire-and-forget requests (e.g. CDN translation revalidation, silent token refresh) whose
 *  failures are already handled by the caller and shouldn't be reported as if the main API
 *  were unreachable.
 *
 *  Lives in its own file (rather than on HttpTimeoutInterceptor itself) so services that need
 *  it — like AuthService, which HttpTimeoutInterceptor also depends on for logout401() — can
 *  import it without creating a circular module dependency. */
export const SILENT_REQUEST = new HttpContextToken<boolean>(() => false);
